import { Component, OnInit,EventEmitter,Output, TemplateRef, ViewChild, ElementRef, ChangeDetectorRef,Input } from '@angular/core';import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute, ChildrenOutletContexts } from '@angular/router';
import { FormsService } from '../services/forms.service';
import { SignaturePad } from 'ngx-signaturepad/signature-pad';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
//import {saveAs} from 'file-saver';
import { I18nInterface} from 'ngx-image-drawing'
// import * as jspdf from 'jspdf';  
import html2canvas from 'html2canvas';


@Component({
  selector: 'app-doc-preview',
  templateUrl: './document-preview.component.html',
  styleUrls: ['./document-preview.component.scss']
})

export class DocumentPreviewComponent implements OnInit {
  geolocationPosition: any;
  signOpt: string = 'draw';
  signName: string;
  flash:boolean = false;
  showFiles:boolean = false;
  token:any="";
  participantJson:any={};
  locale:string ="en"; 
  particiantJsonList:any=[];
  projectDocumentsDetailsList:any=[];
  pjtDocumentImgThumbs:any=[];
  signOrInitialImageObj: any[];
  signInitialFontFamily: any;
  signatureBase64: string;
  rows: any = [];
  column: any = [];
  tblrows:any;
  tblcoloumn:any;
  buttonText:string='Button';
  highLightColor:any;
  xposition:any;
  yposition:any;
  selectedDocumentId: any;
  @ViewChild(SignaturePad) signaturePad: SignaturePad;

  public i18n: I18nInterface={
    saveBtn:"Save as image as JPEG",
    sizes:{extra:"Extra"}
  }
   @Output() 
   dateChange:EventEmitter< MatDatepickerInputEvent< any>>;
  tblrowsnumber:any;
  tblclmnumber:any;
  tblid:any;
  tbldata:any;
  Imageurl:any;
  selected:any;

  readonly:any;
  isRequired:any;
  ControlId:any;
  ControlData:any;
  formData: FormData = new FormData();
  signaturePadOptions: any = { 
    'minWidth': 5,
    'canvasWidth': 500,
    'canvasHeight': 300,
    'penColor':"#000000f2"
  };
  brushColor:string=""
  // public signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
  //   'minWidth': 5,
  //   'canvasWidth': 500,
  //   'canvasHeight': 300
  // };
  bulletFieldArray: Array<any> = [];
  bulletFieldAttribute: any = {
    val: '',
  };
  radioButtonGroupFieldArray:Array<any>=[];
  radioButtonGroupFieldAttribute: any = {
    val: '',
  };
  fontSize=[
    { fontsize:7 },
    { fontsize:8 },
    { fontsize:9 },
    { fontsize:10 },
    { fontsize:11 },
    { fontsize:12 },
    { fontsize:14 },
    { fontsize:16 },
    { fontsize:18 },
    { fontsize:20 },
    { fontsize:22 },
    { fontsize:24 },
    { fontsize:26 },
    { fontsize:28 },
    { fontsize:36 },
    { fontsize:48 },
    { fontsize:72 }
  ]

  family = [
    {font: 'Architects Daughter, cursive'},
    {font: 'Dancing Script, cursive'},
    {font: 'Pacifico, cursive'},
    {font: 'Satisfy, cursive'},
    {font: 'Caveat, cursive'},
    {font: 'Cookie, cursive'},
    {font: 'Great Vibes, cursive'},
    {font: 'Parisienne, cursive'},
    {font: 'Sacramento, cursive'},
    {font: 'Yellowtail, cursive'},
    {font: 'Alex Brush, cursive'},
    {font: 'Allura, cursive'},
    {font: 'Damion, cursive'},
    {font: 'Homemade Apple, cursive'},
    {font: 'Leckerli One, cursive'},
    {font: 'Mr Dafoe, cursive'},
    {font: 'Nothing You Could Do, cursive'},
    {font: 'Pinyon Script, cursive'},
    {font: 'Tangerine, cursive'},
    {font: 'Cedarville Cursive, cursive'},
    {font: 'Grand Hotel, cursive'},
    {font: 'Herr Von Muellerhoff, cursive'},
    {font: 'Italianno, cursive'},
    {font: 'Kristi, cursive'},
    {font: 'Niconne, cursive'},
    {font: 'Norican, cursive'},
    {font: 'Petit Formal Script, cursive'},
    {font: 'Rochester, cursive'},
    {font: 'Bilbo Swash Caps, cursive'},
    {font: 'Clicker Script, cursive'},
    {font: 'Dawning of a New Day, cursive'},
    {font: 'Euphoria Script, cursive'},
    {font: 'Ma Shan Zheng, cursive'},
    {font: 'Mr De Haviland, cursive'},
    {font: 'Qwigley, cursive'},
    {font: 'Sofia Script, cursive'},
    {font: 'The Girl Next Door, cursive'},
    {font: 'Zeyada, cursive'},
    {font: 'Beth Ellen, cursive'},
    {font: 'Charmonman, cursive'},
    {font: 'Devonshire, cursive'},
    {font: 'Dr Sugiyama, cursive'},
    {font: 'Engagement, cursive'},
    {font: 'League Script, cursive'},
    {font: 'Meie Script, cursive'},
    {font: 'Mr Bedfort, cursive'},
    {font: 'Romanesco, cursive'},
    {font: 'Stalemate, cursive'},
    {font: 'Zhi Mang Xing, cursive'},
  ]  

  fontfamilys = [
    {font: 'Arail'},
    {font: 'Calibri'},
    {font: 'Roboto'},
    {font: 'Tahoma'},
    {font: 'Verdana'},
  ] 
  dropdownFieldArray:  Array<any> = [];
  dropdownFieldAttribute: any = {
    val: '',
  };

  checkboxFieldArray:  Array<any> = [];
  checkboxFieldAttribute: any = {
    val: '',
  };

  checkboxGroupFieldArray:  Array<any> = [];
  checkboxGroupFieldAttribute: any = {
    val: '',
  };
  
  characterlimit:any;
  textColor:any;
  fontsize:any;
  fontstyle:any;
  fontweight:any;
  textdecoration:any;
  fontfamily:any;
  textalign:any;



  showToolsLeft: boolean = false;
  ShowtoolDetail: boolean = false;
  Sdropdown: boolean = false;
  SURLL: boolean = false;
  Smuldropdown: boolean = false;
  Sbutton: boolean = false;
  Stext: boolean = false;
  SButtontext: boolean = false;
  SURL: boolean = false;
  Ssingleline: boolean = false;
  Sformat: boolean = true;
  Snumber: boolean = false;
  Sradio: boolean = false;
  Scheckbox: boolean = false;
  Scheckboxgroup: boolean = false;
  Stable: boolean = false;
  Sbullet: boolean = false;
  Sdraw: boolean = false;
  Sline: boolean = false;
  ShighLight:boolean=false;
  Sthrough:boolean=false;
  Smeasure: boolean = false;
  rotationByDegree:number=0;
  Smultiline: boolean = false;
  Sapproval: boolean = false;
  SwhiteOut:boolean = false;
  Ssign:boolean=false;
  SreadOnly:boolean=false;

  Ssignature: boolean = false;
  Sinitials: boolean = false;
  Sdate: boolean = false;
  Stime: boolean = false;
  Slocation: boolean = false;

  SbuttonLabel: boolean = false
  Sfile:boolean=false;
  Simage:boolean=false;


  buttonURL:string="";
  acceptOrdeclineText:string="";
  acceptchecked:boolean=false;
  declinechecked:boolean=false;
  dropdownddisabled:boolean=false;

  showHeader:boolean=false;
  showSidebar:boolean=false;

  movingOffset = { x: 0, y: 0 };
  endOffset = { x: 0, y: 0 };

  text:string="";
  groupRelationParticipantId:string="";
  projectDocumentImagesList:any=[];
  IsSigningComplete:boolean=false;
  participantArray: any=[];
  
  @ViewChild('content') content: ElementRef;
  @Input() public modifiedParticipantJson = "";
  @Input() public pagesList = [];
  responseArray: any=[]; 
  
  constructor(private dialog: MatDialog,private router:Router,private route: ActivatedRoute,
    private formsService:FormsService,private loaderService: LoaderService,private toastr: ToastrService,
    private cdr: ChangeDetectorRef) { }  

  ngAfterViewInit() {
    // this.signaturePad is now available
   // this.signaturePad.set('minWidth', 5); // set szimek/signature_pad options at runtime
   // this.signaturePad.clear(); // invoke functions from szimek/signature_pad API
  }

  getBase64Image(img) {
      var canvas1 = document.createElement("canvas");    
      canvas1.width = img.width;
      canvas1.height = img.height;
      var ctx = canvas1.getContext("2d");
      ctx.drawImage(img, 0, 0);
      var dataURL = canvas1.toDataURL("image/png");
      return dataURL;
  }      

  base64(url){
    return this.projectDocumentImagesList.find(m=>m.pageImageUrl==url).pageImageBase64;
 }

 allPdfHTML:any=[];
 allPdfHTML1:any=[];

  
  
  isPageLoaded:boolean=false;

  ngOnInit(): void {    
    this.isPageLoaded=false;
    this.bulletFieldArray.push(this.bulletFieldAttribute); 
    this.dropdownFieldArray.push(this.dropdownFieldAttribute); 
    this.checkboxFieldArray.push(this.checkboxFieldAttribute);
    this.checkboxGroupFieldArray.push(this.checkboxGroupFieldAttribute);
    this.radioButtonGroupFieldArray.push(this.radioButtonGroupFieldAttribute);
    this.highLightColor=this.hexToRGBA("#FFFF00",0.2);
    this.text="";
      
    this.particiantJsonList=this.modifiedParticipantJson;
    this.pjtDocumentImgThumbs = [this.pagesList];  
    this.isPageLoaded=true;
  }



  
  spinner:boolean=false;
  getParticipantJson(){
    this.responseArray=[];
    let reqModel ={
      token:encodeURIComponent(decodeURIComponent(this.token))     
    }
    
  }

  expandProjectImages(projectDocId){
    this.pjtDocumentImgThumbs=[];    
    this.projectDocumentImagesList.forEach(docImgThumbs => {
      if(docImgThumbs.documentID == projectDocId)
      this.pjtDocumentImgThumbs.push(docImgThumbs);
    });
   
  }


  FillDocImagesWithFields(docId:number=0,isUpdateJson:boolean=false) {
    if(isUpdateJson && (this.CheckIfRequiredFieldsAreFilled())) {
      //Prepare Json previously selected participant
      
      let findPreviouslyparticipant=this.participantArray.find(m=>
       m.documentID==this.selectedDocumentId);
     if(findPreviouslyparticipant){
    this.participantArray.find(m=> m.documentID==this.selectedDocumentId).participantJson=JSON.stringify(this.particiantJsonList);
    }else{
      let Current=this.participantJson.find(m=>
        m.documentID==this.selectedDocumentId);
        this.participantArray.push({
          groupRelationParticipantMappingID:this.groupRelationParticipantId,
          participantJson:JSON.stringify(this.particiantJsonList),
          documentID:this.selectedDocumentId,
          projectParticipantJsonID:Current==undefined?0: Current.projectParticipantJsonID
        })
    
   }
    }
     let doc:any;
     if((docId>0)&&(this.CheckIfRequiredFieldsAreFilled())){
      // this.pjtDocumentImgThumbs=[];    
      // this.projectDocumentImagesList.forEach(docImgThumbs => {
      //   if(docImgThumbs.documentID == docId)
      //   this.projectDocumentsDetailsList.pjtDocumentImgThumbs
      //   this.pjtDocumentImgThumbs.push(docImgThumbs);
      // });
      // let ProjDocs = this.projectDocumentImagesList.find(p=>p.documentID==docId);
      // ProjDocs.pjtDocumentImgThumbs=this.pjtDocumentImgThumbs;
 
    //  if(doc){
       this.selectedDocumentId=docId;     
         let selectedParticipantJson=  this.participantArray.find(m=>m.documentID==this.selectedDocumentId);
              if(selectedParticipantJson==undefined){
                selectedParticipantJson=  this.participantJson.find(m=>m.documentID==this.selectedDocumentId);
              }

           if(selectedParticipantJson){
             this.particiantJsonList=JSON.parse(selectedParticipantJson.participantJson);
      //        if(selectedParticipantJson.hasCompleted==null)
      //           this.IsSigningComplete = false;
      //           else
      //             this.IsSigningComplete = selectedParticipantJson.hasCompleted;                
      // // this.projectDocumentImagesList.forEach(docImgT
           }     
           else{
            let partcipantJsonn=  this.participantJson.find(m=>m.documentID==this.selectedDocumentId);
            if(partcipantJsonn==undefined){
              let images=this.projectDocumentImagesList.filter(m=>m.documentID==this.selectedDocumentId); 
              images.forEach(e => {
                this.particiantJsonList.push({img: e.pageImageUrl,fields: [],projectParticipantJsonID:0})
              });
            }
            else{
            this.particiantJsonList=JSON.parse(partcipantJsonn.participantJson);
            if(partcipantJsonn.hasCompleted==null)
            this.IsSigningComplete = false;
            else
             this.IsSigningComplete = partcipantJsonn.hasCompleted;
            }
           }
      //}
     document.getElementsByClassName('docSign')[0].scrollTop = 0;
   }
   else{
     this.selectedDocumentId = this.projectDocumentImagesList[0].documentID;
     //this.selectedDocumentId = this.projectDocumentsDetailsList[0].projectDocumentID;
     let Current=this.participantJson.find(m=>
      m.documentID==this.selectedDocumentId);
      if(Current==undefined){
      //  if( this.participantJson[0].hasCompleted==null)
      //  this.IsSigningComplete = false
      //  else
      //  this.IsSigningComplete = true;
        this.particiantJsonList=[];
        let images=this.projectDocumentImagesList.filter(m=>m.documentID==this.selectedDocumentId); 
        images.forEach(e => {
          this.particiantJsonList.push({img: e.pageImageUrl,fields: [],projectParticipantJsonID:0})
        });
      }
      else{
    this.particiantJsonList = JSON.parse(Current.participantJson);
  //   if(Current.hasCompleted==null)
  //  this.IsSigningComplete = false;
  //  else
  //   this.IsSigningComplete = Current.hasCompleted;
      // this.projectDocumentImagesList.forEach(docImgThumbs => {
      //   if(docImgThumbs.documentID == this.selectedDocumentId)
      //   this.projectDocumentsDetailsList.pjtDocumentImgThumbs
      //   this.pjtDocumentImgThumbs.push(docImgThumbs);
      // });
      // let ProjDocs = this.projectDocumentImagesList.find(p=>p.documentID==docId);
      // ProjDocs["pjtDocumentImgThumbs"]=this.pjtDocumentImgThumbs;
      //this.projectDocumentImagesList.find(p=>p.documentID==docId) = ProjDocs;

      // if(Current.hasCompleted!=null)
      // this.IsSigningComplete = Current.hasCompleted;
      }

   
      document.getElementsByClassName('docSign')[0].scrollTop = 0;
      
   }
  }
 
  
  showAllFiles(){
    this.showFiles = !this.showFiles
  }

  OnAcceptOrDecline(e: any,isAccecpt:boolean){
    let ctrl=this.ControlData;
    let ctrlId=this.ControlId;
   
    if (this.particiantJsonList.find(x => x.img == ctrl.img) && this.particiantJsonList.find(x => x.img == ctrl.img).fields.length > 0){
      if(isAccecpt) {
         this.particiantJsonList.find(x => x.img == ctrl.img).fields.find(m=>m.id==ctrlId).buttonText='Approve';
         this.acceptOrdeclineText='Approve';
        } else {
          this.particiantJsonList.find(x => x.img == ctrl.img).fields.find(m=>m.id==ctrlId).buttonText='Decline';       
          this.acceptOrdeclineText='Decline';
        }
    }
  }
  
  checkBoxRequiredEvent(event) {
  var data= this.ControlData;
  if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
    //this.changesForUndo.push(JSON.parse(JSON.stringify( this.imagesWithFields)));
    this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).isRequired = event.checked == undefined ? '' :  event.checked;
    this.particiantJsonList = this.particiantJsonList;
   // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
  }
  }

checkBoxReadOnlyEvent(event) {
  var data= this.ControlData;
  if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
     // this.changesForUndo.push(JSON.parse(JSON.stringify( this.imagesWithFields)));
    this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).readonly = event.checked == undefined ? '' :  event.checked;
    this.particiantJsonList = this.particiantJsonList;
   // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
  }
}

onChangeTextAlign(textalign:any) {
  var data= this.ControlData;
  if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
   // this.changesForUndo.push(JSON.parse(JSON.stringify( this.particiantJsonList)));
    this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).textalign = textalign == undefined ? '' :  textalign;
    this.particiantJsonList = this.particiantJsonList;
    this.textalign=textalign;
  }
}

onChangetblrows(rows:any) {
  this.tblcoloumn=(<HTMLInputElement>document.getElementById('txt-tbl-column')).value;
  if(rows=='' || rows==0 || this.tblcoloumn=='' || this.tblcoloumn==0 ) {
    return;
  }
  this.rows=[];
  this.column=[];
  this.tblrows= Number(rows);
  if( this.tblcoloumn==undefined){
    this.tblcoloumn=2;
  }
  this.GettableWithFields(Number(rows),Number(this.tblcoloumn));
}

onChangetblclm(clm:any) {  
  this.tblrows=(<HTMLInputElement>document.getElementById('txt-tbl-row')).value;
  if(clm=='' || clm==0 || this.tblrows=='' || this.tblrows==0 ) {
    return;
  }
  this.rows=[];
  this.column=[];
  this.tblcoloumn= Number(clm);
  if( this.tblrows==undefined){
    this.tblrows=2;
  }
  this.GettableWithFields(Number(this.tblrows),Number(clm));
}


  
GettableWithFields(rows:any,coloumn:any) {
  this.rows=[];
  this.column=[];
  for (var i = 0, len = rows; i < len; ++i) {
    var req = {        
    }
    this.rows.push(req)
  }
  for (var i = 0, len = coloumn; i < len; ++i) {
    var req = {        
    }
    this.column.push(req)
  }

  if( this.tblid !=undefined){
  if (this.particiantJsonList.find(x => x.img == this.tbldata.img) && this.particiantJsonList.find(x => x.img == this.tbldata.img).fields.length > 0) {
    let length = this.rows*this.column;
    let oldFillList=this.particiantJsonList.find(x => x.img == this.tbldata.img).fields.find(m => m.id == this.tblid).fillList;
    let fillList=[];
      for (let r = 0; r < this.rows.length; r++) {
        for (let c = 0; c < this.column.length; c++) {
          if(oldFillList.some(m=>m.id=='txt-'+(r+1)+''+(c+1))){
            fillList.push({
              val: oldFillList.find(m=>m.id=='txt-'+(r+1)+''+(c+1)).val,
              id:'txt-'+(r+1)+''+(c+1)
            });
          } else {
            fillList.push({
              val: '',
              id:'txt-'+(r+1)+''+(c+1)
            });
         }
        }
      }
    //  this.changesForUndo.push(JSON.parse(JSON.stringify( this.imagesWithFields)));
    this.particiantJsonList.find(x => x.img == this.tbldata.img).fields.find(m => m.id == this.tblid).rows= this.rows;//.push(this.rows);
    this.particiantJsonList.find(x => x.img == this.tbldata.img).fields.find(m => m.id == this.tblid).column =this.column;//.push(this.column)
    this.particiantJsonList.find(x => x.img == this.tbldata.img).fields.find(m => m.id == this.tblid).fillList =fillList;//.push(this.column)
    this.particiantJsonList = this.particiantJsonList;   
  }
}
}

onChangecheckboxGrouplist(string:any,row:any) {     
  this.checkboxGroupFieldArray.forEach((element) => {
    var val = string;     
  });    
  if( this.ControlId !=undefined) {
    if (this.particiantJsonList.find(x => x.img == this.ControlData.img) && this.particiantJsonList.find(x => x.img == this.ControlData.img).fields.length > 0) {
      var FieldsDetails = (this.particiantJsonList.find(x => x.img == this.ControlData.img))
      var getData = FieldsDetails.fields.filter(x => x.id ===  this.ControlId);      
    }
  }
}

onChangeText(value: any) {
  var data= this.ControlData;
  if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
   // this.changesForUndo.push(JSON.parse(JSON.stringify( this.imagesWithFields)));
    this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).selectedValue = value == undefined ? '' : value;     
    this.particiantJsonList = this.particiantJsonList;
    this.characterlimit;
   // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
  }
}

  isDrawing:boolean = false;
 // imgsDrawn:any=[];
  previousdrawings:any=[];
  
  drawonImg(){
  var canvases = document.getElementsByTagName("canvas");
 
  if(!this.IsSigningComplete){
    this.isDrawing = !this.isDrawing;
  // Array.from(canvases).forEach((canvasElement,index) => {
  //   var canvas = canvasElement as HTMLCanvasElement;

  //   if(!this.isDrawing){  
  //     var dataURL = canvas.toDataURL();  
  //     // var imgd = document.getElementById("canvasimg") as HTMLImageElement;
  //     //imgd.src = dataURL;
  //     var imgContainer = " <img id='canvasimg' style='z-index:1' style='position: absolute;left: 0px; top: 0px;' src='"+dataURL+"'>"
  //     this.imgsDrawn.push(imgContainer);
  //     var currntObj = this.particiantJsonList[index];
  //     if(currntObj.drawings!=undefined){
  //     if(currntObj.drawings.length>=0){
  //       this.previousdrawings.push(JSON.parse(JSON.stringify(currntObj.drawings)));
  //       currntObj.drawings.push(imgContainer);
        
  //     }
  //   }
  //     else{  
  //       currntObj["drawings"]= this.imgsDrawn;
  //     }
    
  //     //document.getElementById("canvasimg").style.display = "inline";
    
  //   }
    
  // });
      this.indicesDrawn.forEach(element=>{
        var canvas = element[0].canv as HTMLCanvasElement;

        if(!this.isDrawing){  
          var dataURL = canvas.toDataURL();  
          var imagsDrawn = [];
          // var imgd = document.getElementById("canvasimg") as HTMLImageElement;
          //imgd.src = dataURL;
          var imgContainer = " <img id='canvasimg' style='z-index:1' style='position: absolute;left: 0px; top: 0px;' src='"+dataURL+"'>"
          imagsDrawn.push(imgContainer);
          var currntObj = this.particiantJsonList[element[0].key];
          if(currntObj.drawings!=undefined){
          if(currntObj.drawings.length>=0){
            this.previousdrawings.push(JSON.parse(JSON.stringify(currntObj.drawings)));
            currntObj.drawings.push(imgContainer);
            
          }
        }
          else{  
            currntObj["drawings"]= imagsDrawn;
          }
        
          //document.getElementById("canvasimg").style.display = "inline";
        
        }
      })

  }
 
  }
indicesDrawn:Array<any>=[];

  // getDrawnIndices(values){
  //   this.indicesDrawn = values;
  // }

  canvasIndex:number =0;
  setIndex(index){
    this.canvasIndex = index;
    if(this.indicesDrawn.indexOf(index)<0)
    this.indicesDrawn.push(index);
  }
  Cleardrawing(){
  //   var currntObj =   this.particiantJsonList[this.canvasIndex];
  //   if(currntObj.drawings!=undefined){
  //   if(currntObj.drawings.length>=0){
  //     currntObj.drawings =this.previousdrawings[this.canvasIndex];
  //   }
  // }
  //   else{  
  //     currntObj["drawings"]= [];
  //   }
    this.indicesDrawn=[];
    this.isDrawing = !this.isDrawing;
  }
  
  setHeight(index:any){
    var imgHeight = document.getElementById("imgSrc"+index) as HTMLImageElement;
    return imgHeight.offsetHeight;
  }

onChangeRadioButtonGrouplist(string:any,row:any) {     
  this.radioButtonGroupFieldArray.forEach((element) => {
    var val = string;     
  });    
  if( this.ControlId !=undefined) {
    if (this.particiantJsonList.find(x => x.img == this.ControlData.img) && this.particiantJsonList.find(x => x.img == this.ControlData.img).fields.length > 0) {
      var FieldsDetails = (this.particiantJsonList.find(x => x.img == this.ControlData.img))
      var getData = FieldsDetails.fields.filter(x => x.id ===  this.ControlId);        
    }
  }
}

addValueFielbullet() {
  this.bulletFieldAttribute = null;
  let tempObject = Object.assign({}, this.bulletFieldAttribute);
  this.bulletFieldArray.push(tempObject);
}

addValueFielDropDown() {
  this.dropdownFieldAttribute = null;
  let tempObject = Object.assign({}, this.dropdownFieldAttribute);
  this.dropdownFieldArray.push(tempObject);
}

addValueFielCheckBox() {
  this.checkboxFieldAttribute = null;
  let tempObject = Object.assign({}, this.checkboxFieldAttribute);
  this.checkboxFieldArray.push(tempObject);
}

deleteField(value,row:any) {  
  if (value == 'b') {
    const index = this.bulletFieldArray.indexOf(row);
      if (index >= 0) {
      this.bulletFieldArray.splice(index, 1);
    }     
  } 
  else if (value == 'd') {
    const index = this.dropdownFieldArray.indexOf(row);
      if (index >= 0) {
      this.dropdownFieldArray.splice(index, 1);
    }     
  }
   else if (value == 'c') {
    const index = this.checkboxGroupFieldArray.indexOf(row);
    if (index >= 0) {
    this.checkboxGroupFieldArray.splice(index, 1);
   }
  }    
  else if (value == 'r') {
    const index = this.radioButtonGroupFieldArray.indexOf(row);
    if (index >= 0) {
    this.radioButtonGroupFieldArray.splice(index, 1);
  }     
 }   
}

onChangeTextBoldFont(bold:any) {
   if(this.fontstyle == "bold"){
     bold="";
   }
  var data= this.ControlData;
  if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
    //this.changesForUndo.push(JSON.parse(JSON.stringify( this.particiantJsonList)));
    this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).fontstyle = bold == undefined ? '' :  bold;
    this.particiantJsonList = this.particiantJsonList;
    this.fontstyle= bold;
 }
}

onChangeTextItalicFont(italic:any) {
  if(this.fontweight == "italic"){
    italic="";
  }
  var data= this.ControlData;
  if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
    //this.changesForUndo.push(JSON.parse(JSON.stringify( this.particiantJsonList)));
    this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).fontweight = italic == undefined ? '' :  italic;
    this.particiantJsonList = this.particiantJsonList;
    this.fontweight= italic;
 }
}

onChangeTextDecoration(textdecoration:any) {
  if(this.textdecoration == "underline" || this.textdecoration == "line-through"){
    textdecoration="";
  }
  var data= this.ControlData;
  if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
   // this.changesForUndo.push(JSON.parse(JSON.stringify( this.particiantJsonList)));
    this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).textdecoration = textdecoration == undefined ? '' :  textdecoration;
    this.particiantJsonList = this.particiantJsonList;
    this.textdecoration= textdecoration;
 }
}

onChangeFontSize(event) {
  var data= this.ControlData;
  var size = event.value +"px";
  if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
   // this.changesForUndo.push(JSON.parse(JSON.stringify( this.particiantJsonList)));
    this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).fontSize = size == undefined ? '' :  size;
    this.particiantJsonList = this.particiantJsonList;
 }
}


onChangeNumberValue(number:any){
  var data= this.ControlData;
  if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
   // this.changesForUndo.push(JSON.parse(JSON.stringify( this.particiantJsonList)));
    this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).selectedValue = number == undefined ? '' :  number;
    this.particiantJsonList = this.particiantJsonList;
 }
}

onChangeFontFamily(event) {
  var data= this.ControlData;
  var family = event.value;
  if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
   // this.changesForUndo.push(JSON.parse(JSON.stringify( this.particiantJsonList)));
    this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).fontfamily = family == undefined ? '' :  family;
    this.particiantJsonList = this.particiantJsonList;
    this.fontfamily=family;
  }
}

onChangeImageWidth(widthImage:any) {
  var data = this.ControlData;
  if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
  //  this.changesForUndo.push(JSON.parse(JSON.stringify( this.particiantJsonList)));
    this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).Imagewidth = widthImage == undefined ? '' :  widthImage;
    this.particiantJsonList = this.particiantJsonList;   
   // sessionStorage.setItem('particiantJsonList',JSON.stringify(this.particiantJsonList));
  }
}

onChangeImageHeight(heightImage:any) {
  var data = this.ControlData;
  if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
   // this.changesForUndo.push(JSON.parse(JSON.stringify( this.particiantJsonList)));
    this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).Imageheight = heightImage == undefined ? '' :  heightImage;
    this.particiantJsonList = this.particiantJsonList;   
   // sessionStorage.setItem('particiantJsonList',JSON.stringify(this.particiantJsonList));
  }
}

onChangeCharLimit(charLimit:any) {
  var data= this.ControlData;
  if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
   // this.changesForUndo.push(JSON.parse(JSON.stringify( this.imagesWithFields)));
    this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).charLimit = (charLimit) == undefined ? '' :  (charLimit);
    this.particiantJsonList = this.particiantJsonList;
   // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
  }
}
  onChangeTextButton(value: any) {
    var data= this.ControlData;
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).buttonName = value == undefined ? '' : value;
     // this.changesForUndo.push(JSON.parse(JSON.stringify( this.imagesWithFields)));
      this.particiantJsonList = this.particiantJsonList;     
     // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }

  onChangeUrlButton(value: any) {
    var data= this.ControlData;
    var url = this.addAnchorsToText(value);
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
    //  this.changesForUndo.push(JSON.parse(JSON.stringify( this.imagesWithFields)));
      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).buttonURL = url == undefined ? '' : url;     
      this.particiantJsonList = this.particiantJsonList;   
     // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }


  onChangedropdownlist(string:any) {  
    this.dropdownFieldArray.forEach((element) => {
      var val = string;     
    });    
    if( this.ControlId !=undefined) {
      if (this.particiantJsonList.find(x => x.img == this.ControlData.img) && this.particiantJsonList.find(x => x.img == this.ControlData.img).fields.length > 0) {
        //this.changesForUndo.push(JSON.parse(JSON.stringify( this.imagesWithFields)));
        this.particiantJsonList.find(x => x.img == this.ControlData.img).fields.find(m => m.id == this.ControlId).fillList= this.dropdownFieldArray;       
        this.particiantJsonList = this.particiantJsonList;
      }
    }
  }

  onChangecheckboxlist(string:any) {  
    this.checkboxFieldArray.forEach((element) => {
      var val = string;     
    });    
    if( this.ControlId !=undefined) {
      if (this.particiantJsonList.find(x => x.img == this.ControlData.img) && this.particiantJsonList.find(x => x.img == this.ControlData.img).fields.length > 0) {
        
        var FieldsDetails = (this.particiantJsonList.find(x => x.img == this.ControlData.img))
        var getData = FieldsDetails.fields.filter(x => x.id ===  this.ControlId);
        if(getData.length > 0) {          
          var data = getData[0].fillList[0];
          var objNew =[]
          var obj={
            id: data.id,
            offsetX: data.offsetX,
            offsetY: data.offsetY,
            val: string
          }
        }
        objNew.push(obj);
        //this.changesForUndo.push(JSON.parse(JSON.stringify( this.imagesWithFields)));
        this.particiantJsonList.find(x => x.img == this.ControlData.img).fields.find(m => m.id == this.ControlId).fillList = objNew;       
        this.particiantJsonList = this.particiantJsonList;
      }
    }
  }
  
  insertIntoString(str: string, pos: number, fragment: string) {
    return str.slice(0, pos) + fragment + str.slice(pos + 1, str.length);
  }

  addAnchorsToText(text) {
    // https://www.regextester.com/94502
    const regexp = /((?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+%,;=.]+)/igm;
    const map = {};
    return text.replace(regexp, (_, match, __, pos) => {
        // This map helps us to keep a count of the duplicate matches.
        if (map[match] !== undefined) map[match]++;
        else map[match] = 0;

        // These next few lines handle duplicates. We want to handle cases like this: 
        // <a href="myurl.com">foo</a> bar baz myurl.com.
        let testString = text.replace(new RegExp(escapeRegExp(match), 'ig'), '$');
        let newPos = pos - map[match] * (match.length - 1);
        testString = this.insertIntoString(testString, newPos, match);

        // Detect if the url was found here -> <a href="#here#">
        const hrefRegex = new RegExp(`<a[^>]*href="${escapeRegExp(match)}"[^>]*>[^<]*<\/a>`, 'ig');
        const isHref = hrefRegex.test(testString);

        // Detect if the url was found here -> <a href="...">#here#</a>
        const anchoredRegex = new RegExp(`<a[^>]*>[^<]*${escapeRegExp(match)}[^<]*<\/a>`, 'ig');
        const isAnchored = anchoredRegex.test(testString);

        
        // If the url is found in href or anchor, then do nothing with it, it needs no further treatment.
        if (isAnchored || isHref) return match;
        const hasProtocol = /^http[s]?:\/\/.*$/igm.test(match);
        //var data = "http://'}${match}";
        return `${hasProtocol ? '' : 'http://'}${match}`;
    });
    function escapeRegExp(text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
  }
}

  fillForms(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef,{
      panelClass: 'selectParticipants',
    });
  }

  fillRequrieds(templateRef: TemplateRef<any>) {

    //this.CheckIfRequiredFieldsAreFilled();
    this.dialog.open(templateRef,{
      panelClass: 'selectParticipants',
    });
  }

  assignOther(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef,{
      panelClass: 'selectParticipants',
    });
  }

  innerhtmlvalue :string ="";
  drawingImgeHeight:string ="";
  SignatureAcceptance(templateRef: TemplateRef<any>) {
    this.innerhtmlvalue = document.getElementById("docSign").innerHTML;
    
    var drwImgContainrt = document.getElementById("imageDrawContainer");
    if(drwImgContainrt!=null){
      this.drawingImgeHeight = drwImgContainrt.offsetHeight.toString();
    }
    this.dialog.open(templateRef,{
      panelClass: 'selectParticipants',
    });
  }
  fetchLocation(data,id) {
    if (window.navigator && window.navigator.geolocation) {
      window.navigator.geolocation.getCurrentPosition(
          position => {
              this.geolocationPosition = position
              if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
                this.particiantJsonList.find(x => x.img == data.img).fields.find(n=>n.id==id).Lat
                =this.geolocationPosition!==undefined && this.geolocationPosition!==null && this.geolocationPosition!==''? this.geolocationPosition.coords.latitude:'';
                this.particiantJsonList.find(x => x.img == data.img).fields.find(n=>n.id==id).Long
                =this.geolocationPosition!==undefined && this.geolocationPosition!==null && this.geolocationPosition!==''?this.geolocationPosition.coords.longitude:'';
              }
          },
          error => {
              switch (error.code) {
                  case 1:
                     
                      break;
                  case 2:
                    
                      break;
                  case 3:
                    
                      break;
              }
          }
      );
  };
  }



 
onSelectFile(event,data: any,id) {
  this.projectDocumentImagesList;
  this.projectDocumentsDetailsList;
 
  var ProjectDocumentID= this.projectDocumentImagesList.filter(x => x.pageImageUrl == data.img);
  var documentId= ProjectDocumentID[0].documentID;
  var filename = event.target.files;
  for (let i = 0; i < filename.length; i++){
    var ext = filename[i].name.split('.').pop();
    const file = event.target.files[i];
    
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      var FullPath = filename[i].name;
      var documentNameSplit = FullPath.split('.');
      var documentName = documentNameSplit[0];
      var documenttype = documentNameSplit[1];

      var base64String = reader.result;  
      var projectDocumentIDFromResponse;
      this.responseArray;
      
      this.formData.append('UserID', this.responseArray.userID);
      this.formData.append('ProjectName', this.responseArray.projectName);
      this.formData.append('ProjectID', this.responseArray.projectID);
      this.formData.append('ProjectDocumentID', "0");
      this.formData.append('ParentDocumentID', documentId);
      this.formData.append('DocumentName', documentName);
      this.formData.append('file', event.target.files[i]);
      this.formData.append('DocumentType', documenttype);    
      this.formData.append('DatabaseID', this.responseArray.databaseID);
      this.formData.append('OrganizationID', this.responseArray.organizationID);
      this.formsService.AddProjectAttachmentDocument(this.formData).subscribe((response) => {
        if (response != undefined) {          
          projectDocumentIDFromResponse= response.data.projectDocumentID;
          var FileObj =[];
          FileObj.push({
            FullPath:FullPath,
            FileName: documentName,
            FileExtention: documenttype,
            FilePath:filename[i],
            Base64String:base64String,
            projectDocumentID:projectDocumentIDFromResponse
        });      
         if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
          //this.changesForUndo.push(JSON.parse(JSON.stringify( this.imagesWithFields)));
         let fillList= this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).fillList;
         this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).FileData = FileObj      
         this.particiantJsonList = this.particiantJsonList;
       }
        }else{ 
        }
      });
  
     
 }  
 // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));    
}    
}


getColumnValue(data:any,tblId:any,row:any,col:any) {
  let id ='txt-'+row+col;
  let val='';
  if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
    val=  this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == tblId).fillList.find(m=>m.id==id).val;
  }
  return val;
}

controlAlignArray:any=[]
OpentoolDetailtbl (data: any, id) {
  if(!this.controlAlignArray.find(m=>m.id==id)){
  this.controlAlignArray.push({
    fieldTypeName:this.particiantJsonList.find(x => x.img == data.img).fields.find(n=>n.id==id).fieldTypeName,
    img:data.img,
    id:id
  });
}
 this.tbldata=data;
 this.tblid=id;

 var check = data.fields.filter((s) => s.id ==id);
 if(check.length > 0 ){
  this.tblrowsnumber = check[0].rows.length;
  this.tblclmnumber = check[0].column.length;
 }
}


onTableChange(e: any, data: any, id) {
  if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
 //   this.changesForUndo.push(JSON.parse(JSON.stringify( this.imagesWithFields)));
    this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).fillList.find(m=>m.id==e.target.id).val = e.target.value == undefined ? '' : e.target.value;
  
    this.particiantJsonList = this.particiantJsonList;
   // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
  }    
}

OpentoolDetailDropDown (data: any, id) {
  if(!this.controlAlignArray.find(m=>m.id==id)){
  this.controlAlignArray.push({
    fieldTypeName:this.particiantJsonList.find(x => x.img == data.img).fields.find(n=>n.id==id).fieldTypeName,
    img:data.img,
    id:id
  });
}
this.particiantJsonList.find(x => x.img == data.img).fields.forEach(element => {
  if(element.id!=id)
  element.ShowtoolDetail = false;
});
  if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
    var FieldsDetails = (this.particiantJsonList.find(x => x.img == data.img))
    var getData = FieldsDetails.fields.filter(x => x.id ===  id);
    if(getData.length > 0){
      if(getData[0].fieldTypeName == "Dropdown" ){
        this.dropdownFieldArray= getData[0].fillList;          
      }
      if(getData[0].fieldID > 0 ){
       this.dropdownddisabled =true;      
      }else{
        this.dropdownddisabled =false;
      }
      this.text = getData[0].selectedValue;
      this.ControlData = FieldsDetails;
      this.ControlId = id;
      this.isRequired = getData[0].isRequired;
      this.readonly = getData[0].readonly;
      this.characterlimit = getData[0].charLimit;
      this.textColor = getData[0].fontColor;
      var size = getData[0].fontSize.substr(0, getData[0].fontSize.length-2);
      this.fontsize = Number(size);
      this.fontstyle = getData[0].fontstyle;
      this.fontweight = getData[0].fontweight;
      this.textdecoration = getData[0].textdecoration;
      this.fontfamily = getData[0].fontfamily; 
      this.textalign= getData[0].textalign;    
     // this.selectedParticipant=getData[0].selectedParticipant;   
    }     
   // this.onclickMenu(this.selectedParticipant.colourCode,this.selectedParticipant);  
    // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
  }
 }


  setDdlValue(e: any, data: any, id) {
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
     // this.changesForUndo.push(JSON.parse(JSON.stringify( this.imagesWithFields)));
      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).selectedValue = e.value;
      this.particiantJsonList = this.particiantJsonList;
     // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }

  // addSignature(templateRef: TemplateRef<any>) {
  //   this.dialog.open(templateRef,{
  //     panelClass: 'selectParticipants',
  //   });
  // }
 

  flashFields(){
    this.flash = !this.flash
  }

  close() {
    this.dialog.closeAll();
  }

  OpentoolDetailText (data: any, id) {
    if(!this.controlAlignArray.find(m=>m.id==id)){
    this.controlAlignArray.push({
      fieldTypeName:this.particiantJsonList.find(x => x.img == data.img).fields.find(n=>n.id==id).fieldTypeName,
      img:data.img,
      id:id
    });
  }
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      var FieldsDetails = (this.particiantJsonList.find(x => x.img == data.img))
      var getData = FieldsDetails.fields.filter(x => x.id ===  id);
      if(getData.length > 0){        
        this.text = getData[0].selectedValue;
        this.ControlData = FieldsDetails;
        this.ControlId = id;
        this.isRequired = getData[0].isRequired;
        this.readonly = getData[0].readonly;
        this.characterlimit = getData[0].charLimit;
        this.textColor = getData[0].fontColor;
        var size = getData[0].fontSize.substr(0, getData[0].fontSize.length-2);
        this.fontsize = Number(size);
        this.fontstyle = getData[0].fontstyle;
        this.fontweight = getData[0].fontweight;
        this.textdecoration = getData[0].textdecoration;
        this.fontfamily = getData[0].fontfamily;
        this.textalign = getData[0].textalign;
        //this.selectedParticipant=getData[0].selectedParticipant;
        this.buttonText = getData[0].buttonName;
        this.buttonURL = getData[0].buttonURL;
        this.acceptOrdeclineText  =getData[0].buttonText
       

        if(this.acceptOrdeclineText=="Approve"){
         this.acceptchecked=true;
         this.declinechecked=false;
        }
        if(this.acceptOrdeclineText=="Decline"){
          this.declinechecked=true;
         this.acceptchecked=false;
         }
         
        if(this.buttonURL !="" && this.buttonURL!=undefined && this.buttonURL !=''){
          const url = this.buttonURL;
          window.open(url, '_blank');
        }
        this.particiantJsonList.find(x => x.img == data.img).fields.forEach(element => {
          if(element.id!=id)
          element.ShowtoolDetail = false;
        });
        //this.onclickMenu(this.selectedParticipant.colourCode,this.selectedParticipant);      
      } 
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
   }


   scrollToPage(pageNo:any) {
    const elementToScroll: HTMLElement=document.getElementById("docHolding"+pageNo);
    document.getElementsByClassName('docSign')[0].scrollTop=elementToScroll.offsetTop-100;
  }

   checkIfEnabled(field):boolean{   
     return ((!this.IsSigningComplete) && (field.selectedParticipant.groupRelationParticipantMappingID == this.groupRelationParticipantId));   
   }
   

  isControlEnabled:boolean = false;
   verifyParticipant(field:any,event:any){
    if(!this.IsSigningComplete){
    if(field.selectedParticipant.groupRelationParticipantMappingID != this.groupRelationParticipantId){
      this.ShowtoolDetail=false;
      field.isControlEnabled = true;
      event.preventDefault();   
    
    }
    else{
      field.isControlEnabled = false;
    }
   }
   else{
    this.ShowtoolDetail=false;
    field.isControlEnabled = true;
    event.preventDefault();   
   }
   }


   controlIndex:number =0;

   movetoNextControl(){
    if(this.ControlData==undefined){
      if(this.controlIndex==0|| this.controlIndex==undefined){
        if(this.controlIndex==undefined) this.controlIndex=0;
      let element: HTMLElement = document.getElementsByClassName("iframe-drag-handle")[this.controlIndex] as HTMLElement;
      element.dispatchEvent(new Event('click'));
  
      element.childNodes.forEach(node=>{
      
        if(node.nodeType<8){
        let child = node as HTMLElement;
        if(child.lastElementChild){
          var lastelemnt = child.lastElementChild as HTMLElement;
          lastelemnt.click();
          lastelemnt.focus();
        }
        else{
          child.click();
          child.focus();
        }
        }
       
            
      });
      this.controlIndex = 0;    
    }
      //element.click();
    }
    else{
      if (this.particiantJsonList.find(x => x.img == this.ControlData.img) && this.particiantJsonList.find(x => x.img == this.ControlData.img).fields.length > 0) {
        //  this.changesForUndo.push(JSON.parse(JSON.stringify( this.imagesWithFields)));
        //  let currentControl =  this.particiantJsonList.find(x => x.img == this.ControlData.img).fields.find(m => m.id == this.ControlId);
        //  let index = this.particiantJsonList.find(x => x.img == t;his.ControlData.img).fields.indexOf(currentControl);
       var iframeElements =  document.getElementsByClassName("iframe-drag-handle");
       if(this.controlIndex<iframeElements.length)
         this.controlIndex =   this.controlIndex +1;
         else
          this.controlIndex=0;

         //let nextCtrol = this.particiantJsonList.find(x => x.img == this.ControlData.img).fields[this.controlIndex];
         if(this.controlIndex==undefined) this.controlIndex=0;
         
         let element: HTMLElement = iframeElements[this.controlIndex] as HTMLElement;
         element.click();
         element.childNodes.forEach(node=>{
          if(node.nodeType<8){
            let child = node as HTMLElement;
            if(child.lastElementChild){
              var lastelemnt = child.lastElementChild as HTMLElement;
              lastelemnt.click();
              lastelemnt.focus();
            }
            else{
              child.click();
              child.focus();
            }
            }          
         });
        }
    }

   }

   AcceptBtnClick(){
    if(!this.IsSigningComplete){
    if(this.CheckIfRequiredFieldsAreFilled()){

      let findPreviouslyparticipant=this.participantArray.find(m=>
        m.documentID==this.selectedDocumentId);
        if(findPreviouslyparticipant){
        this.participantJson.find(m=> m.documentID==this.selectedDocumentId).participantJson=JSON.stringify(this.particiantJsonList);
       }else{
        let Current=this.participantJson.find(m=>
          m.documentID==this.selectedDocumentId);
        this.participantArray.push({
          groupRelationParticipantMappingID:this.groupRelationParticipantId,
          participantJson:JSON.stringify(this.particiantJsonList),
          documentID:this.selectedDocumentId,
          projectParticipantJsonID:Current.projectParticipantJsonID
        })
      } 
        
       this.pjtDocumentImgThumbs;
       this.projectDocumentsDetailsList;    
       var allPdfHTML=[];  
      
       for(var i=0; i< this.projectDocumentsDetailsList.length;i++){    
          
        let Current=this.participantJson.find(m=> m.documentID==this.projectDocumentsDetailsList[i].projectDocumentID);
        this.particiantJsonList = JSON.parse(Current.participantJson);
        this.cdr.detectChanges();

        var height = document.getElementById("docHolding1") as HTMLImageElement;
        var newimgHeight =(height.offsetHeight)+'px'.toString();
        var newimgwidth =(height.offsetWidth)+'px'.toString();       
      
        var html="<html lang=&quot;en&quot;><head> <link href='https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap' rel='stylesheet'> <meta charset=&quot;utf-8&quot;><meta name=&quot;viewport&quot; content=&quot;width=device-width, initial-scale=1&quot;><style>.next {display:none; } .docHolding {position:relative} #imageDrawContainer {vertical-align:top;display:block;left:auto!important;} .iframe-drag-handle { background-color: transparent !important;border: none !important } input, textarea, .customUpdate, .Dtime { background-color: transparent !important; border: none !important; resize: none !important }.mat-icon-button, ngx-material-timepicker-toggle, input[type='file']{ display: none !important } table{ border: none !important;border-spacing: 0 !important }  </style></head><body style=&quot;background: #979797;&quot; > <div style='width:"+newimgwidth+"; margin: auto; height: auto;'>  "+ this.innerhtmlvalue +"</div>  </body> </html>"
      
        var imgHeight = document.getElementById("imgSrc"+0) as HTMLImageElement;
        var req={
          documentName:this.projectDocumentsDetailsList[i].documentName,
          projectDocumentId:this.projectDocumentsDetailsList[i].projectDocumentID,
          documentHtml:html,
          pageWidth:(height.offsetWidth).toString(),
          pageHeight:(imgHeight.offsetHeight).toString()
        }
        req.documentHtml = req.documentHtml as any;
        allPdfHTML.push(req);
     } 
  
       let reqPayload = {
        token:encodeURIComponent(decodeURIComponent(this.token)),
        groupRelationParticipantMappingID:this.groupRelationParticipantId,
        participantJsonList :this.participantArray,
        documentHtmls:allPdfHTML
       };
       this.dialog.closeAll();
       this.loaderService.show();
       // return;  
        this.formsService.updateParticipantJson(reqPayload).subscribe(response=>{       
        this.dialog.closeAll();
        this.router.navigate(['/request/thanks']);
        this.loaderService.hide();
       });
    }else{
      this.dialog.closeAll();
    }
  
  }else{
    this.dialog.closeAll();
    this.toastr.warning('The document has already been signed cannot re-submit it.');
  }


   }

   onClickOutside(event:Object) {
    this.ShowtoolDetail = false;   
    this.controlAlignArray = [];
    // var data= this.ControlData;
    // if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
    //   this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).ShowtoolDetail = false;
    //   this.imagesWithFields = this.imagesWithFields;   
    // }
    this.particiantJsonList.map(function(entry) {
      entry.fields.map(function(fieldentry) {
        fieldentry.ShowtoolDetail =false;
        return entry;
    });
  });

  } 

  OpentoolDetail(message: any) {   
    this.ShowtoolDetail = false;//!this.ShowtoolDetail
    this.showToolsLeft = false;
    this.Sdropdown = false;
    this.Smuldropdown=false;
    this.Sbutton = false;
    this.Snumber = false;
    this.Sradio = false;
    this.Scheckbox = false;
    this.Scheckboxgroup=false;
    this.Stable = false;
    this.Sbullet = false;
    this.Sformat = false;
    this.Sdraw = false;
    this.Stext = false;
    this.SButtontext=false;
    this.SURL= false;
    this.Smeasure = false;
    this.Sline = false;
    this.Smultiline = false;
    this.Ssingleline = false;
    this.Sthrough=false;
    this.SwhiteOut=false;
    this.ShighLight=false;
    this.Ssignature = false;
    this.Sinitials = false;
    this.Sapproval = false;
    this.Sdate = false;
    this.Stime = false;
    this.Slocation = false;

    this.SbuttonLabel = false;
    this.Simage = false;
    this.Sfile = false;
    this.SURLL=false;

    if (message == 'Signature') {
      this.Ssignature = true;
    }

    if (message == 'Initials') {
      this.Sinitials = true;
    }

    if (message == 'File') {
      this.Sfile = true;
    }

    if (message == 'Image') {
      this.Simage = true;
    }

    if (message == 'Location') {
      this.Slocation = true;
      this.Sformat = true;
    }

    if (message == 'Time') {
      this.Stime = true;
      this.Sformat = true;
    }

    if (message == 'Date') {
      this.Sdate = true;
      this.Sformat = true;
    }

    if (message == 'ApproveOrDecline') {
      this.Sapproval = true;
      this.SreadOnly = false;
     // this.Srequired = true;
      this.Sbutton = true;
      this.Sformat = true;
    }

    if (message == 'Textbox') {
      this.Ssingleline = true;
      this.Stext = true;
      this.Sformat = true;     
    }

    if (message == 'BulletList') {
      this.Sformat = true;
      this.Sbullet = true;
    }

    if (message == 'Textarea') {
      this.Smultiline = true;
      this.Stext = true;
      this.Sformat = true;
    }

    if (message == 'Date') {
      this.Sformat = true;
    }

    if (message == 'line' || message=='StraightLine') {
      this.Sline = true;
    }

    if (message == 'measure') {
      this.Smeasure = true;
    }

    if (message == 'Draw') {
      this.Sdraw = true;
    }
    

    if (message == 'format') {
      this.Sformat = true;
    }

    if (message == 'Table') {
      this.Stable = true;
      this.Stext = false;
    }

    if (message == 'text') {
      this.Stext = true;
      this.Sformat = true;
    }

    if (message == 'Radio') {
      this.Sradio = true;
      this.Sformat = true;
    }

    if (message == 'Checkbox') {
      this.Scheckbox = true;
      this.Sformat = true;
    }

    if (message == 'CheckBoxGroup') {
      this.Scheckboxgroup = true;
      this.Sformat = true;
    }

    if (message == 'MultiSelect') {     
       this.Smuldropdown=true;
       this.Sformat = true;
    }

    if (message == 'Dropdown') {
      this.Sdropdown = true;
      this.Sformat = true;
    }

    if (message == 'Button') {
      this.SbuttonLabel = true;     
      this.SButtontext=true;
      this.SURL=true;     
      this.Sformat = true;
    }

    if (message == 'Number') {
      this.Snumber = true;
      this.Sformat = true;
    }
    if(message=='StrikeThrough'){
      this.Sthrough=true;
    }
    if(message=="WhiteOut"){
      this.SwhiteOut=true;
    }

    if(message=="HighLight"){
      this.ShighLight=true;
    }
    if(message=="URL"){
      this.SURLL=true;
      this.Sformat = true;
    }    
   
  }
  showAllRequiredControls:boolean=false;
  
highlightRequiredControls(){
  this.showAllRequiredControls=!this.showAllRequiredControls;
    this.particiantJsonList.map((entry) =>{
      entry.fields.map((fieldentry)=> {
        if(this.showAllRequiredControls){
        if((fieldentry.isRequired==true)&&(fieldentry.selectedParticipant.groupRelationParticipantMappingID == this.groupRelationParticipantId)){
          fieldentry.showRequiredControls = true;
        }        
      }
      else{
        fieldentry.showRequiredControls = false;      }
        return entry;
    });
  });
  //this.CheckIfRequiredFieldsAreFilled();
  }
    CheckIfRequiredFieldsAreFilled(){
     let AllFieldsAreFilled=true;
     let Counter =0;
   //   this.showAllRequiredControls=!this.showAllRequiredControls;
    this.particiantJsonList.map((entry) =>{
      entry.fields.map((fieldentry)=> {
       // if(this.showAllRequiredControls){
        if((fieldentry.isRequired==true)&&(fieldentry.selectedParticipant.groupRelationParticipantMappingID == this.groupRelationParticipantId)){
          //fieldentry.showRequiredControls = true;
          if((fieldentry.fieldTypeName=="Number")||(fieldentry.fieldTypeName=="Textarea")||(fieldentry.fieldTypeName=="Textbox")||(fieldentry.fieldTypeName=="Dropdown")){
           if(fieldentry.selectedValue==""){
            fieldentry.showRequiredControls = true;
            Counter++;
           }  
          }
         else if((fieldentry.fieldTypeName=="CheckBoxGroup")||(fieldentry.fieldTypeName=="Checkbox")){
            if(fieldentry.chkSelectedValues.length==0){
              fieldentry.showRequiredControls = true;
              Counter++;
            }
          }
          else if((fieldentry.fieldTypeName=="Radio")){
            if(fieldentry.rbSelectedValues.length==0){
              fieldentry.showRequiredControls = true;
              Counter++;
            }
          }
        else  if(fieldentry.fieldTypeName=="Location"){
            if((fieldentry.Lat=="") &&(fieldentry.Long=="")){
              fieldentry.showRequiredControls=true;
              Counter++;
            }
          }
          else if(fieldentry.fieldTypeName=="Signature"){
            if(fieldentry.signatureBase64==""){
              fieldentry.showRequiredControls=true;
              Counter++;
            }
          }
          else if(fieldentry.fieldTypeName=="Initials"){
            if(fieldentry.ImageData==""){
              fieldentry.showRequiredControls=true;
              Counter++;
            }
          }
          else if(fieldentry.fieldTypeName=="Image"){
            if(fieldentry.ImageData==""){
              fieldentry.showRequiredControls=true;
              Counter++;
            }
          }
          else if(fieldentry.fieldTypeName=="File"){
              if(fieldentry.FileData==""){
                fieldentry.showRequiredControls=true;
                Counter++;
              }
          }
          else if(fieldentry.fieldTypeName=="Draw"){
            if(fieldentry.drawBase64==""){
              fieldentry.showRequiredControls=true;
              Counter++;
            }
        }
        }        
      //}
      else{
        fieldentry.showRequiredControls = false;      }
       // return entry;
    });
    });
      if(Counter>0){
        return false;
      }
      else{
        return true;
      }
    }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  addActiveClass(item:any){
    return item.ShowtoolDetail = true;
  }

  OpentoolDetailMulDropDown (data: any, id) {
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      var FieldsDetails = (this.particiantJsonList.find(x => x.img == data.img))
      var getData = FieldsDetails.fields.filter(x => x.id ===  id);
      if(getData.length > 0){
        // if(getData[0].fieldTypeName == "MultiSelect" ){
        //   this.dropdownFieldArray= getData[0].fillList;          
        // }
        if(getData[0].fieldID > 0 ){
         this.dropdownddisabled =true;      
        }else{
          this.dropdownddisabled =false;
        }
        this.text = getData[0].selectedValue;
        this.ControlData = FieldsDetails;
        this.ControlId = id;
        this.isRequired = getData[0].isRequired;
        this.readonly = getData[0].readonly;
        this.characterlimit = getData[0].charLimit;
        this.textColor = getData[0].fontColor;
        var size = getData[0].fontSize.substr(0, getData[0].fontSize.length-2);
        this.fontsize = Number(size);
        this.fontstyle = getData[0].fontstyle;
        this.fontweight = getData[0].fontweight;
        this.textdecoration = getData[0].textdecoration;
        this.fontfamily = getData[0].fontfamily; 
        this.textalign= getData[0].textalign;     
       // this.selectedParticipant=getData[0].selectedParticipant;  
      }     
     // this.onclickMenu(this.selectedParticipant.colourCode,this.selectedParticipant);  
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }

  onSelectImage(event,data: any,id) {
    var filename = event.target.files;
    for (let i = 0; i < filename.length; i++){
      var ext = filename[i].name.split('.').pop();
      if (ext != 'png' && ext != 'jpg' && ext != 'jpeg') {
        alert('only image upload');
        return;
      }
      const file = event.target.files[i];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        this.Imageurl = event.target.result;
        var FullPath = filename[i].name;
        var documentNameSplit = FullPath.split('.');
        var documentName = documentNameSplit[0];
        var documenttype = documentNameSplit[1];
  
        var base64String = reader.result;        
        
        var ImageObj =[];
        ImageObj.push({
          FileName: documentName,
          FileExtention: documenttype,
          FilePath:filename[i],
          Imageurl:base64String
        });     
       if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
       // this.changesForUndo.push(JSON.parse(JSON.stringify( this.particiantJsonList)));
       let fillList= this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).fillList;
       this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).ImageData = ImageObj      
       this.particiantJsonList = this.particiantJsonList;
     }
   }  
   // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));    
  }   
   
  }

  
  AddControlRadioButon(id,data) {
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      let fillList= this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).fillList;
    //  this.changesForUndo.push(JSON.parse(JSON.stringify( this.imagesWithFields)));
      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).fillList.push({
        id:"ctrl-"+(fillList.length+1),
        val: "",
        offsetX: fillList[fillList.length-1].offsetX,
        offsetY: fillList[fillList.length-1].offsetY +37
      });
      this.particiantJsonList = this.particiantJsonList;
      this.radioButtonGroupFieldArray = fillList;
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }

  AddControlCheckBoxGroup(id,data) {
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
    //  this.changesForUndo.push(JSON.parse(JSON.stringify( this.imagesWithFields)));
      let fillList= this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).fillList;
      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).fillList.push({
        id:"ctrl-"+(fillList.length+1),
        val: "",
        offsetX: fillList[fillList.length-1].offsetX,
        offsetY: fillList[fillList.length-1].offsetY +37
      });
      this.particiantJsonList = this.particiantJsonList;
      this.particiantJsonList=fillList;     
    }
  }


  ifChkChecked(id,data,childCtrlId) {
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      let selectedValue= this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues;
    return  selectedValue.includes(childCtrlId);
    }
  return false;
  }

  ifRadioChecked(id,data,childCtrlId) {
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      let selectedValue= this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).rbSelectedValues;
    return  selectedValue.includes(childCtrlId);
    }
  return false;
  }

  OnChangeCheckBoxGroup($event: any, chk: any, id: any, data: any,childCtrlID:any) {
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      if ($event.target.checked) {
       // this.changesForUndo.push(JSON.parse(JSON.stringify( this.imagesWithFields)));
        this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues.push(childCtrlID);
       
        this.particiantJsonList = this.particiantJsonList;
      } else {
        if (
          this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues.find((s) => s == childCtrlID)
        ) {
          this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues =
            this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues.filter((s) => s !== childCtrlID)
        }
      }
    }
    // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
  }

  onChange(value: any, data: any, id) {
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      
      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).selectedValue = value == undefined ? '' : value;     
      this.particiantJsonList = this.particiantJsonList;      
     
      this.text=value;
    }
  }
   
  drawComplete() {
    // will be notified of szimek/signature_pad's onEnd event
    
  }
 
  drawStart() {
    // will be notified of szimek/signature_pad's onBegin event
   
  }
  onStart(event) {
    
   }
 
   onStop(event) {
   
   }
 
   onMoving(event, i) {
     this.movingOffset.x = event.x;
     this.movingOffset.y = event.y;
   }
  
   hexToRGBA(hex, opacity) {
    if(hex==undefined){
      return;
    }
    return  (hex = hex.replace('#', '')).match(new RegExp('(.{' + hex.length/3 + '})', 'g')).map(function(l) { return parseInt(hex.length%2 ? l+l : l, 16) }).concat(isFinite(opacity) ? opacity : 1).join(',') ;
  }
     
  imgDrawStart(){
    // let canvas = document.getElementsByTagName("canvas")[0]; 
    // var context = canvas.getContext('2d');
     if(this.brushColor!="")
     this.signaturePadOptions.penColor = "RGB("+this.hexToRGBA(this.brushColor,1)+")";
     else{
       this.brushColor="#000000";
     this.signaturePadOptions.penColor = "RGB("+this.hexToRGBA(this.brushColor,1)+")"; 
     } 
   }

   currentSign= {
    data:'',
    id:''
  }

  signatureImage:any;

  SaveSign(data) {
    this.signatureImage = data;
  }

  
  onChangebulletlist(string:any) {  
    this.bulletFieldArray.forEach((element) => {
      var val = string ;      
    });   
    if( this.ControlId !=undefined){
      if (this.particiantJsonList.find(x => x.img == this.ControlData.img) && this.particiantJsonList.find(x => x.img == this.ControlData.img).fields.length > 0) {
      //  this.changesForUndo.push(JSON.parse(JSON.stringify( this.imagesWithFields)));
        this.particiantJsonList.find(x => x.img == this.ControlData.img).fields.find(m => m.id == this.ControlId).fillList= this.bulletFieldArray;
        this.particiantJsonList = this.particiantJsonList;
      }
    }
  }

  OpentoolDetailBulletList (data: any, id) {
    if(!this.controlAlignArray.find(m=>m.id==id))
    {
    this.controlAlignArray.push({
      fieldTypeName:this.particiantJsonList.find(x => x.img == data.img).fields.find(n=>n.id==id).fieldTypeName,
      img:data.img,
      id:id
    });
  }
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      var FieldsDetails = (this.particiantJsonList.find(x => x.img == data.img))
      var getData = FieldsDetails.fields.filter(x => x.id ===  id);
      if(getData.length > 0){
        if(getData[0].fieldTypeName == "BulletList" ){
          this.bulletFieldArray= getData[0].fillList;          
        }        
        this.text = getData[0].selectedValue;
        this.ControlData = FieldsDetails;
        this.ControlId = id;
        this.isRequired = getData[0].isRequired;
        this.readonly = getData[0].readonly;
        this.characterlimit = getData[0].charLimit;
        this.textColor = getData[0].fontColor;
        var size = getData[0].fontSize.substr(0, getData[0].fontSize.length-2);
        this.fontsize = Number(size);
        this.fontstyle = getData[0].fontstyle;
        this.fontweight = getData[0].fontweight;
        this.textdecoration = getData[0].textdecoration;
        this.fontfamily = getData[0].fontfamily;
        this.textalign= getData[0].textalign; 
      //  this.selectedParticipant=getData[0].selectedParticipant;     
      }     
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
     // this.onclickMenu(this.selectedParticipant.colourCode,this.selectedParticipant); 
    }
   }

   OpenSignPopup(templateRef: TemplateRef<any>,data:any,item:any) {   
     if(this.checkIfEnabled(item)) {
    this.ControlData=data;
    this.ControlId=item.id;
    if(this.ControlId==undefined){
      this.ControlId=item;
    }

    this.currentSign.data=data;
    this.currentSign.id=item.id;
    // if(item.signatureText==""|| item.signatureText==undefined || item.signatureText==null){
    //   this.signName=this.currentUser.Name;
    // }else{
    //   this.signName=item.signatureText;
    // }
    this.signName="";
    this.selected=''
    this.signOpt = 'draw';   
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
   
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      this.particiantJsonList.find(x => x.img == data.img).fields.forEach(element => {
        if(element.id!=item.id)
        element.ShowtoolDetail = false;
      });
      
      var FieldsDetails = (this.particiantJsonList.find(x => x.img == data.img))
      var getData = FieldsDetails.fields.filter(x => x.id ===  item.id);
      if(getData.length > 0){
        this.ControlData = FieldsDetails;
        this.ControlId = item.id;
        this.isRequired = getData[0].isRequired;
        this.readonly = getData[0].readonly;     
        if(getData[0].brushColor!=undefined)
        this.brushColor = getData[0].brushColor;   
      }     
      this.imgDrawStart();
    }
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }

  drawnImg= {
    data:'',
    id:''
  }

OpenDrawPopup(templateRef: TemplateRef<any>,data:any,field:any,id:any) {
  if(this.checkIfEnabled(field)) {
    this.drawnImg.data=data;
    this.drawnImg.id=id;
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
 
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      this.particiantJsonList.find(x => x.img == data.img).fields.forEach(element => {
        if(element.id!=id)
        element.ShowtoolDetail = false;
      });
      
      var FieldsDetails = (this.particiantJsonList.find(x => x.img == data.img))
      var getData = FieldsDetails.fields.filter(x => x.id ===  id);
      if(getData.length > 0){
        this.ControlData = FieldsDetails;
        this.ControlId = id;
        this.isRequired = getData[0].isRequired;
        this.readonly = getData[0].readonly;     
        if(getData[0].brushColor!=undefined)
        this.brushColor = getData[0].brushColor;  
      }     
      this.imgDrawStart();
    }
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }

  }

  signOrInitialTextChanges(e:any) {
    if(this.signName!=='' && this.signName!==undefined)
    {
    this.signatureBase64=''; 
    this.signOrInitialImageObj=[];  
   }
  }

  setSignInitialFontFamilyChange(e:any) {
    this.signInitialFontFamily=e;
  }

  OpentoolDetailRadioButtonGroup (data: any, id,fillListcontrolId: any) {
    if(!this.controlAlignArray.find(m=>m.id==id)){
    this.controlAlignArray.push({
      fieldTypeName:this.particiantJsonList.find(x => x.img == data.img).fields.find(n=>n.id==id).fieldTypeName,
      img:data.img,
      id:id
    });
  }
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      var FieldsDetails = (this.particiantJsonList.find(x => x.img == data.img))
      var getData = FieldsDetails.fields.filter(x => x.id ===  id);
      if(getData.length > 0){
        if(getData[0].fieldTypeName == "Radio" ){
          this.radioButtonGroupFieldArray= getData[0].fillList;          
        }       
        this.text = getData[0].selectedValue;
        this.ControlData = FieldsDetails;
        this.ControlId = id;
        this.fillListcontrolId=fillListcontrolId;
        this.isRequired = getData[0].isRequired;
        this.readonly = getData[0].readonly;
        this.characterlimit = getData[0].charLimit;
        this.textColor = getData[0].fontColor;
        var size = getData[0].fontSize.substr(0, getData[0].fontSize.length-2);
        this.fontsize = Number(size);
        this.fontstyle = getData[0].fontstyle;
        this.fontweight = getData[0].fontweight;
        this.textdecoration = getData[0].textdecoration;
        this.fontfamily = getData[0].fontfamily;
        this.textalign= getData[0].textalign;     
       // this.selectedParticipant=getData[0].selectedParticipant;
      }     
      //this.onclickMenu(this.selectedParticipant.colourCode,this.selectedParticipant);      
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
   }
   
  fillListcontrolId:any;
  
  OpentoolDetailCheckBoxGroup (data: any, id,fillListcontrolId: any) {
    if(!this.controlAlignArray.find(m=>m.id==id)) {
    this.controlAlignArray.push({
      fieldTypeName:this.particiantJsonList.find(x => x.img == data.img).fields.find(n=>n.id==id).fieldTypeName,
      img:data.img,
      id:id
    });
  }
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      var FieldsDetails = (this.particiantJsonList.find(x => x.img == data.img))
      var getData = FieldsDetails.fields.filter(x => x.id ===  id);
      if(getData.length > 0){
        if(getData[0].fieldTypeName == "CheckBoxGroup"){         
          this.checkboxGroupFieldArray = getData[0].fillList;       
        }
        if(getData[0].fieldID > 0){
         this.checkboxdisabled =true;      
        }else{
          this.checkboxdisabled =false;
        }
        this.text = getData[0].selectedValue;
        this.ControlData = FieldsDetails;
        this.ControlId = id;
        this.fillListcontrolId=fillListcontrolId;
        this.isRequired = getData[0].isRequired;
        this.readonly = getData[0].readonly;
        this.characterlimit = getData[0].charLimit;
        this.textColor = getData[0].fontColor;
        var size = getData[0].fontSize.substr(0, getData[0].fontSize.length-2);
        this.fontsize = Number(size);
        this.fontstyle = getData[0].fontstyle;
        this.fontweight = getData[0].fontweight;
        this.textdecoration = getData[0].textdecoration;
        this.fontfamily = getData[0].fontfamily;
        this.textalign= getData[0].textalign;     
        //this.selectedParticipant=getData[0].selectedParticipant;
      }     
     // this.onclickMenu(this.selectedParticipant.colourCode,this.selectedParticipant);  
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
   }

   onSelectSignImage(event,data: any,id:any) {
    data=this.currentSign.data;
    id=this.currentSign.id;
    var filename = event.target.files;
    for (let i = 0; i < filename.length; i++){
      var ext = filename[i].name.split('.').pop();
      if (ext != 'png' && ext != 'jpg' && ext != 'jpeg') {
        alert('only image upload');
        return;
      }
      const file = event.target.files[i];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        this.Imageurl = event.target.result;
        var FullPath = filename[i].name;
        var documentNameSplit = FullPath.split('.');
        var documentName = documentNameSplit[0];
        var documenttype = documentNameSplit[1];
  
        var base64String = reader.result;        
        
         this.signOrInitialImageObj =[];
         this.signOrInitialImageObj.push({
          FileName: documentName,
          FileExtention: documenttype,
          FilePath:filename[i],
          Imageurl:base64String
        });  
        this.signatureBase64=''; 
        this.signName='';   
        if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
          //this.particiantJsonList.push(JSON.parse(JSON.stringify( this.particiantJsonList)));
          let fillList= this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).fillList;
          this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).signatureBase64 = '';      
          this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).signatureText = ''; 
          this.particiantJsonList = this.particiantJsonList;
        }
   }  
   // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));    
  } 
  }

  checkboxdisabled:boolean =false;
  OpentoolDetailCheckBox (data: any, id,fillListcontrolId: any) {
    if(!this.controlAlignArray.find(m=>m.id==id)) {
    this.controlAlignArray.push({
      fieldTypeName:this.particiantJsonList.find(x => x.img == data.img).fields.find(n=>n.id==id).fieldTypeName,
      img:data.img,
      id:id
    });
  }
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      var FieldsDetails = (this.particiantJsonList.find(x => x.img == data.img))
      var getData = FieldsDetails.fields.filter(x => x.id ===  id);
      if(getData.length > 0){
        if(getData[0].fieldTypeName == "Checkbox" ){
          this.checkboxFieldArray= getData[0].fillList;          
        }
        if(getData[0].fieldID > 0 ){
         this.checkboxdisabled =true;      
        }else{
          this.checkboxdisabled =false;
        }
        this.text = getData[0].selectedValue;
        this.ControlData = FieldsDetails;
        this.ControlId = id;
        this.fillListcontrolId=fillListcontrolId;
        this.isRequired = getData[0].isRequired;
        this.readonly = getData[0].readonly;
        this.characterlimit = getData[0].charLimit;
        this.textColor = getData[0].fontColor;
        var size = getData[0].fontSize.substr(0, getData[0].fontSize.length-2);
        this.fontsize = Number(size);
        this.fontstyle = getData[0].fontstyle;
        this.fontweight = getData[0].fontweight;
        this.textdecoration = getData[0].textdecoration;
        this.fontfamily = getData[0].fontfamily;
        this.textalign= getData[0].textalign; 
       // this.selectedParticipant=getData[0].selectedParticipant;
      }     
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
     // this.onclickMenu(this.selectedParticipant.colourCode,this.selectedParticipant); 
    }
   }

   OnChangeRadio($event: any, rb: any, id: any, data: any,childCtrlID:any) {
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      //this.changesForUndo.push(JSON.parse(JSON.stringify( this.particiantJsonList)));
      if ($event.target.checked) {
       
        this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).rbSelectedValues=[];
        this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).rbSelectedValues.push(childCtrlID);
     
        this.particiantJsonList = this.particiantJsonList;
      } else {
       if (       
          this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).rbSelectedValues.find((s) => s == childCtrlID)
        ) {
          this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).rbSelectedValues =
          this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).rbSelectedValues.filter((s) => s !== childCtrlID)
        }
      }
    }
    // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
  }

   OnChangeCheckBox($event: any, chk: any, id: any, data: any,childCtrlID:any) {
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
     // this.changesForUndo.push(JSON.parse(JSON.stringify( this.imagesWithFields)));
      if ($event.target.checked) {       
        this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues.push(childCtrlID);      
        this.particiantJsonList = this.particiantJsonList;
      } else {
        if (
          this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues.find((s) => s == childCtrlID)
        ) {
          this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues =
          this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues.filter((s) => s !== childCtrlID)
        }
      }
    }
    // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
  }

  drawImgBase64:string;

  addDrawnImg() {
    let data:any=this.drawnImg.data;
    let canvas = document.getElementsByTagName("canvas")[0]; 
    if(canvas!=undefined)
     this.drawImgBase64=canvas.toDataURL();
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
     // this.changesForUndo.push(JSON.parse(JSON.stringify( this.imagesWithFields)));
      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.drawnImg.id).drawBase64 = this.drawImgBase64;      
      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.drawnImg.id).brushColor = this.brushColor;
      
      this.particiantJsonList = this.particiantJsonList;
   }
    this.dialog.closeAll();
  }


  addSignature() {
    let data:any=this.ControlData;
    let canvas = document.getElementsByTagName("canvas")[0]; 
    if(canvas!=undefined){
     this.signatureBase64=canvas.toDataURL();
     this.signName="";
     this.signOrInitialImageObj=[];
    }
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      //this.changesForUndo.push(JSON.parse(JSON.stringify( this.imagesWithFields)));
      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signatureBase64 = this.signatureBase64;      
      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signatureText = this.signName;
      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signInitialFontFamily = this.signInitialFontFamily;
      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).ImageData = this.signOrInitialImageObj;
    
      this.particiantJsonList = this.particiantJsonList;
   }
    this.dialog.closeAll();
  }

  onChangeFontColor(color:any) {
    var data= this.ControlData;
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
     // this.changesForUndo.push(JSON.parse(JSON.stringify( this.imagesWithFields)));
      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).fontColor = color == undefined ? '' :  color;
      this.particiantJsonList = this.particiantJsonList;
      this.textColor=color;
    }
  }
  
  onChangeBackgroundColor(color:any) {
    var data= this.ControlData;
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
     // this.changesForUndo.push(JSON.parse(JSON.stringify( this.imagesWithFields)));
      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).backgroundColor = this.hexToRGBA(color,0.6) == undefined ? '' :  this.hexToRGBA(color,0.6);
      this.particiantJsonList = this.particiantJsonList;
      this.highLightColor=this.hexToRGBA(color,0.2);
    }
  }
  
  onBrushColorChange(color:any) {
   this.brushColor=color;
  }
  
  onRotationValueChange(){
    var data= this.ControlData;
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
    //  this.changesForUndo.push(JSON.parse(JSON.stringify( this.imagesWithFields)));
      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).rotation = this.rotationByDegree;
      this.particiantJsonList = this.particiantJsonList;   
    }
  }

  onChangeXposition(x:any) {  
    var data= this.ControlData;
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
     // this.changesForUndo.push(JSON.parse(JSON.stringify( this.imagesWithFields)));
      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).offsetX = Number(x) == undefined ? '' :  Number(x);
      this.particiantJsonList = this.particiantJsonList;   
     // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }
 
  
  onChangeYposition(y:any) {
    var data= this.ControlData;
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
     // this.changesForUndo.push(JSON.parse(JSON.stringify( this.imagesWithFields)));
     this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).offsetY =  Number(y) == undefined ? '' :  Number(y);
     this.particiantJsonList = this.particiantJsonList;
     // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }
  
  saveBtn($event){
    //saveAs($event,'image.jpg');
  }

  OpenDrawInPopup(templateRef: TemplateRef<any>) {
    // this.drawnImg.data=data;
    // this.drawnImg.id=id;
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    }); 
   
  }
  
}
